import { convertKeysToCamelCase } from "@/lib/format-data";

import type {
  WaitlistMessageAttachment,
  WaitlistMessagePreviewRequest,
  WaitlistMessagePreviewResponse,
  WaitlistMessageRequest,
  WaitlistMessageResponse,
  WaitlistMessageTestResponse,
} from "@/types/waitlist-message";

import { requestData } from "@/api/api-config";

export function previewWaitlistMessage(payload: WaitlistMessagePreviewRequest) {
  return requestData<WaitlistMessagePreviewResponse>(
    "waitlist/messages/preview",
    "post",
    { json: payload },
    false,
  );
}

export function sendWaitlistMessage(payload: WaitlistMessageRequest) {
  return requestData<WaitlistMessageResponse>(
    "waitlist/messages",
    "post",
    { json: payload },
    false,
  );
}

export function testSendWaitlistMessage(payload: WaitlistMessageRequest) {
  return requestData<WaitlistMessageTestResponse>(
    "waitlist/messages/test-send",
    "post",
    { json: payload },
    false,
  );
}

export async function uploadWaitlistMessageFiles(files: File[]) {
  const formData = new FormData();
  for (const file of files) formData.append("files", file);
  const result = await requestData<Record<string, unknown>[]>(
    "waitlist/messages/upload",
    "post",
    { body: formData },
  );
  return result
    ? (convertKeysToCamelCase(result) as WaitlistMessageAttachment[])
    : null;
}
